import React from 'react'
import SignUpForm from 'src/components/pages/signUp'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store/store'
import { useRouter } from 'next/router'
import HeadTag from 'src/components/layout/head'
import { getCookie } from 'cookies-next'

function SignUp() {
  const router = useRouter()
  const zenMode = useSelector((state: RootState) => state.zenModeState.zenMode)
  const lang = getCookie('lang')

  React.useEffect(() => {
    const userToken: string | null =
      typeof window === 'object' ? localStorage.getItem('dtl_token') : null
    if (userToken) {
      if (JSON.parse(userToken).id) router.push('/profile')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <HeadTag
        title={
          lang === 'En'
            ? `Ditch The Label - Sign up`
            : ` Quítate las etiquetas - crea una cuenta`
        }
      />
      <div>
        <SignUpForm zenMode={zenMode} />
      </div>
    </>
  )
}

export default SignUp
